import { EnvironmentPort } from '../application/ports/environment/EnvironmentPort';
import { Logger } from '../domain/Logger';

export class NodeEnvironmentAdapter implements EnvironmentPort {
  private readonly envVars: Record<string, string | undefined>;

  constructor(private readonly logger: Logger) {
    this.envVars = { ...process.env };
    logger.debug('⚙️ Loaded environment variables:', this.envVars);
  }

  getBaseUrl(): string {
    return this.getRequired('REACT_APP_BASE_URL');
  }

  getDataProcessingAgreementStorageUrl(): string {
    return this.getRequired('REACT_APP_DATA_PROCESSING_AGREEMENT_STORAGE_URL');
  }

  getFbPixelId(): string {
    return this.get('REACT_APP_FB_PIXEL_ID') || '';
  }

  getGaTrackingId(): string {
    return this.get('REACT_APP_GA_TRACKING_ID') || '';
  }

  getLandingPageUrl(): string {
    return this.getRequired('REACT_APP_LANDINGPAGE_URL');
  }

  getLinkedinPixelPartnerId(): string {
    return this.get('REACT_APP_LINKEDIN_PIXEL_PARTNER_ID') || '';
  }

  getPipelineCreatedAt(): string | undefined {
    return this.get('REACT_APP_PIPELINE_CREATED_AT');
  }

  getPipelineId(): string | undefined {
    return this.get('REACT_APP_PIPELINE_ID');
  }

  getStaticAssetUrl(): string {
    return this.getRequired('REACT_APP_STATIC_ASSET_URL');
  }

  isFollowingDeepLinksEnabled(): boolean {
    return !this.getRequiredBoolean('REACT_APP_DISABLE_FLOW_DEEP_LINKING_PROTECTION');
  }

  private get(key: string): string | undefined {
    return this.envVars[key];
  }

  private getRequired(key: string): string {
    const value = this.get(key);
    if (value === undefined || value === '') {
      throw new Error(`Environment variable ${key} is required but was not provided.`);
    }

    return value;
  }

  private getBoolean(key: string): boolean | undefined {
    const value = this.get(key);

    if (value === undefined) return undefined;

    const lowercased = value.toLowerCase();
    if (lowercased === 'true' || lowercased === '1') return true;
    if (lowercased === 'false' || lowercased === '0') return false;

    throw new Error(`Environment variable ${key} cannot be parsed as boolean: ${value}`);
  }

  private getRequiredBoolean(key: string): boolean {
    const value = this.getBoolean(key);

    if (value === undefined) {
      throw new Error(`Environment variable ${key} is required but was not provided.`);
    }

    return value;
  }
}
